module.exports = __webpack_public_path__ + "static/media/suuRed.045cf487.svg";